import { useSite } from './use-site';
export var useLinearMenu = function () {
  var site = useSite();
  return site.linearMenu;
};